import * as React from 'react';
import Button from '@mui/material/Button';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import Box from '@mui/material/Box';

const sendCurlRequest = async () => {
    const url = "https://qadx.qinlinad.com/monitor/event";
    const currentTime = Math.floor(Date.now() / 1000); // 获取当前时间戳

    const data = {
        age: 0,
        communityId: "13121",
        time: currentTime,  // 使用当前时间戳
        type: 9,
        slotId: "ADS-200629-18074734475",
        userId: 1744364,
        adMode: 108,
        group_id: "1",
        city: "北京市市辖区",
        device: "63AC6006-B487-4C86-B77F-FD0A768209CF",
        communityName: "慧谷时空",
        gender: 0
    };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Host": "qadx.qinlinad.com",
                "Content-Type": "application/json;charset=UTF-8",
                "Accept": "*/*",
                "qplatform": "1",
                "qvendor": "APPLE",
                "Accept-Language": "zh-CN,zh-Hans;q=0.9",
                "qsdkversioncode": "100",
                "User-Agent": "App/3110 (iPhone; CPU iPhone OS 17_1 like Mac OS X)",
                "qchannel": "Apple Store",
                "qversioncode": "3110"
            },
            body: JSON.stringify(data)
        });

        const result = await response.json();
        console.log('Request successful:', result);
        // 你可以根据返回的数据进行其他操作，例如页面跳转等
    } catch (error) {
        console.error('Error in request:', error);
    }
};
export default function DoorOpen() {
    return (
        <Box sx={{
            display: 'flex', // 启用 Flexbox 布局
            justifyContent: 'center', // 水平居中
            alignItems: 'center', // 垂直居中
            height: '100vh', // 占满视口高度
            backgroundColor: '#f5f5f5' // 设置背景颜色，方便测试
        }}>

            <Button
                variant="contained"
                // type="primary"
                size="large"
                // icon={<LockOpenIcon />}
                onClick={sendCurlRequest}
            >
                开门
            </Button>
        </Box>
    )
}